var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5312,
    cy: 15.2031,
    r: 15,
    fill: "#9C4900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6961 12.5391H16.3628V16.7057H14.6961V12.5391ZM14.6953 17.5391H16.362V19.2057H14.6953V17.5391Z",
    fill: "#F6EFE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0073 7.70531C16.7173 7.15948 16.1523 6.82031 15.534 6.82031C14.9156 6.82031 14.3506 7.15948 14.0606 7.70615L7.94564 19.2586C7.80995 19.5123 7.74273 19.797 7.75062 20.0846C7.75851 20.3722 7.84124 20.6528 7.99064 20.8986C8.13789 21.1456 8.34701 21.3499 8.59735 21.4914C8.84769 21.6329 9.1306 21.7066 9.41814 21.7053H21.6498C22.2398 21.7053 22.774 21.4036 23.0781 20.8986C23.2273 20.6527 23.3099 20.3721 23.3178 20.0846C23.3257 19.7971 23.2586 19.5124 23.1231 19.2586L17.0073 7.70531ZM9.41814 20.0386L15.534 8.48615L21.654 20.0386H9.41814Z",
    fill: "#F6EFE9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.a6ec6b76725ab71bab61f760d95137a2.svg";
export { ForwardRef as ReactComponent };